(function () {
	"use strict";
	if (window.PartifyPartsPaintColorPreview) {
		window.PartifyPartsPaintColorPreview.initialize();
		return;
	}
	const assets = new Map();
	let preparing = null;
	function loadAsset(url, type, disclaimer) {
		if (!url) return Promise.reject(new Error("Missing paint preview asset"));
		if (assets.has(url)) return assets.get(url);
		const promise = new Promise(function (resolve, reject) {
			const element = document.createElement(type === "css" ? "link" : "script");
			if (type === "css") { element.rel = "stylesheet"; element.href = url; }
			else { element.src = url; if (disclaimer) element.dataset.previewDisclaimer = disclaimer; }
			element.onload = resolve;
			element.onerror = function () { element.remove(); assets.delete(url); reject(new Error("Paint preview asset unavailable")); };
			document.head.appendChild(element);
		});
		assets.set(url, promise);
		return promise;
	}
	function start() {
		const panel = document.querySelector("[data-parts-paint-preview]");
		if (!panel || panel.dataset.bound) return;
		if (!preparing) {
			const data = panel.dataset;
			preparing = Promise.all([
				loadAsset(data.colorDetailsCss, "css"),
				loadAsset(data.previewCss, "css"),
				window.PartifyTouchupColorDetails ? Promise.resolve() : loadAsset(data.colorDetailsSrc, "js", data.previewDisclaimer),
			]);
		}
		preparing.then(initialize).catch(function () { preparing = null; });
	}
	function initialize() {
		const panel = document.querySelector("[data-parts-paint-preview]");
		const colors = window.PartifyTouchupColorDetails;
		if (!panel || !colors || panel.dataset.bound) return;
		panel.dataset.bound = "true";
		panel.style.removeProperty("display");
		const photo = panel.querySelector("[data-parts-paint-photo]");
		const controls = panel.closest(".combined-variant-dropdown");
		const placeholder = panel.querySelector("[data-parts-paint-placeholder]");
		const placeholderLabel = panel.querySelector("[data-parts-paint-placeholder-label]");
		const status = panel.querySelector("[data-parts-paint-status]");
		const enlarge = panel.querySelector("[data-parts-paint-enlarge]");
		const dialog = controls.querySelector("[data-parts-paint-dialog]");
		let selectionKey = null;
		let resetting = false;
		let revision = 0;
		let scheduled = false;
		let inView = false;
		const viewed = new Set();
		const optionLabels = new WeakMap();
		let namesKey = "";
		let namesRevision = 0;
		let colorDetails = null;
		function vehicle() {
			try {
				const saved = typeof window.getSearchTerms === "function"
					? window.getSearchTerms()[0]
					: JSON.parse(localStorage.getItem("searchTerms") || "[]")[0];
				return saved || window.PartifyFitment?.getActiveVehicle?.() || null;
			} catch (_) { return null; }
		}
		function paintCode(value) {
			const code = String(value || "").split(" / ").pop().trim();
			return !code || /^(?:unpainted|\.?vin)$/i.test(code) || /match.*vin/i.test(code)
				? "" : code.toUpperCase();
		}
		function selection() {
			const request = window.PartifyPaintDecoderRequest;
			const select = controls.querySelector("#variant-selector");
			const option = select?.options[select.selectedIndex];
			if (request?.status === "pending" || select?.disabled || !option?.value || option.disabled ||
				option.dataset.unavailable === "true" || controls.querySelector("#checkbox-select-unpainted")?.checked) return null;
			const active = vehicle();
			if (!active || !colors.key(active)) return null;
			const manual = controls.querySelector("#checkbox-select-paint-option")?.checked;
			const stored = controls.querySelector("#checkbox-paint-code-local-storage")?.checked;
			if (!manual && (!stored || (request && request.status !== "resolved"))) return null;
			const code = manual
				? paintCode(option.dataset.variantTitle)
				: paintCode(active.paintCode) || paintCode(active.troublesome_format);
			return code ? {vehicle: active, code: code, key: colors.key(active) + "|" + code,
				source: manual ? "manual" : active.plate || active.licensePlate ? "plate" : active.vin ? "vin" : "stored"} : null;
		}
		function resetPhoto() {
			if (dialog.open) dialog.close();
			enlarge.disabled = true;
			placeholder.hidden = false;
			resetting = true;
			colors.renderPreview(photo, null, "");
			resetting = false;
		}
		function namesContext() {
			if (window.PartifyPaintDecoderRequest?.status === "pending") return null;
			// Prepare labels for the active vehicle before the paint selector is opened.
			// Decoder and vehicle-revision guards still prevent stale names being shown.
			const active = vehicle();
			return active && colors.key(active) ? active : null;
		}
		function updateNames() {
			Array.from(controls.querySelector("#variant-selector")?.options || []).forEach(function (option) {
				let saved = optionLabels.get(option);
				if (!saved || option.textContent !== saved.rendered) saved = {base: option.textContent};
				const name = colors.name(colorDetails, paintCode(option.dataset.variantTitle));
				const price = saved.base.match(/\s+[+-].*$/);
				const title = price ? saved.base.slice(0, price.index) : saved.base;
				saved.rendered = name ? title + " \u2014 " + name + (price ? price[0] : "") : saved.base;
				optionLabels.set(option, saved);
				if (option.textContent !== saved.rendered) option.textContent = saved.rendered;
			});
		}
		function refreshNames() {
			const active = namesContext();
			const key = active ? colors.key(active) : "";
			if (key !== namesKey) {
				namesKey = key;
				colorDetails = null;
				const job = ++namesRevision;
				const loadNames = typeof colors.loadNames === "function" ? colors.loadNames : colors.load;
				if (active) loadNames.call(colors, active, post, window.shopCurrency || "USD").then(function (details) {
					const current = namesContext();
					if (job !== namesRevision || !current || colors.key(current) !== key) return;
					colorDetails = details;
					updateNames();
				}).catch(function () {
					// Retry on the next user/vehicle event, without an automatic request loop.
					if (job === namesRevision && namesKey === key) namesKey = "";
				});
			}
			updateNames();
		}
		function post(payload) {
			const canadian = window.shopCurrency === "CAD";
			const url = canadian ? "https://auto-realm.myshopify.com/api/2024-01/graphql.json" : "/api/2024-01/graphql.json";
			const token = canadian ? "2bcf68ed45edc56c19f2f3aa226eb101" : "12ccfcd74b8bc4e56ce0762f51fcf438";
			const controller = new AbortController();
			const timeout = setTimeout(function () { controller.abort(); }, 8000);
			return fetch(url, {
				method: "POST",
				headers: {"Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": token},
				body: JSON.stringify(payload), signal: controller.signal,
			}).then(function (response) {
				if (!response.ok) throw new Error("Color preview unavailable");
				return response.json();
			}).finally(function () { clearTimeout(timeout); });
		}
		function refresh() {
			scheduled = false;
			refreshNames();
			const current = selection();
			const key = current?.key || "";
			if (key === selectionKey) return;
			selectionKey = key;
			const job = ++revision;
			resetPhoto();
			// A paint method alone is not a selected color; keep the empty card hidden.
			panel.hidden = true;
			placeholderLabel.textContent = current?.code || panel.getAttribute("aria-label");
			status.textContent = current ? panel.dataset.previewLoading : "";
			if (!current) return;
			colors.load(current.vehicle, post, window.shopCurrency || "USD", current.code).then(function (details) {
				if (job !== revision || selection()?.key !== key) return;
				placeholderLabel.textContent = colors.label(details, current.code);
				colors.renderPreview(photo, details, current.code);
			}).catch(function () {
				if (job === revision) panel.hidden = true;
			});
		}
		function schedule() {
			if (scheduled) return;
			scheduled = true;
			requestAnimationFrame(refresh);
		}
		function recordView() {
			const current = selection();
			if (!inView || panel.hidden || photo.hidden || photo.hasAttribute("aria-busy") || !current ||
				viewed.has(current.key)) return;
			viewed.add(current.key);
			window.igEvents = window.igEvents || [];
			window.igEvents.push({event: "parts_paint_color_preview_view", properties: {
				page_path: window.location.pathname,
				product_handle: panel.dataset.productHandle || "", paint_code: current.code, selection_source: current.source,
			}});
		}
		photo.addEventListener("partify:paint-preview:visibility", function () {
			if (resetting || selection()?.key !== selectionKey) return;
			panel.hidden = photo.hidden;
			placeholder.hidden = !photo.hidden;
			enlarge.disabled = photo.hidden;
			status.textContent = photo.hidden ? panel.dataset.previewUnavailable : "";
			recordView();
		});
		enlarge.addEventListener("click", function () {
			if (photo.hidden || photo.hasAttribute("aria-busy") || selection()?.key !== selectionKey) return;
			const expanded = photo.cloneNode(true);
			expanded.removeAttribute("data-parts-paint-photo");
			dialog.querySelector("[data-parts-paint-dialog-photo]").replaceChildren(expanded);
			dialog.showModal();
		});
		dialog.querySelector("[data-parts-paint-close]").addEventListener("click", function () { dialog.close(); });
		dialog.addEventListener("click", function (event) {
			if (event.target !== dialog) return;
			const rect = dialog.getBoundingClientRect();
			if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
		});
		dialog.addEventListener("close", function () { dialog.querySelector("[data-parts-paint-dialog-photo]").replaceChildren(); });
		const visibility = new IntersectionObserver(function (entries) {
			inView = entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.1; });
			recordView();
		}, {threshold: 0.1});
		visibility.observe(panel);
		controls.addEventListener("change", schedule);
		controls.addEventListener("click", schedule);
		["partify:paint-selection:changed", "partify:vehicle:changed", "searchTermsUpdated", "pageshow"].forEach(function (event) {
			window.addEventListener(event, schedule);
		});
		const observer = new MutationObserver(schedule);
		const select = controls.querySelector("#variant-selector");
		if (select) observer.observe(select, {childList: true, subtree: true, attributes: true});
		schedule();
	}
	window.PartifyPartsPaintColorPreview = {initialize: start};
	document.addEventListener("shopify:section:load", start);
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, {once: true});
	else start();
})();
